import { userManager } from '@/auth';
import { useUserStore } from '@/stores/user';

export async function loginUser() {
  await userManager.signinRedirect();
}

export async function handleCallback() {
  const user = await userManager.signinRedirectCallback();
  return user;
}

export async function getUser() {
  const user = await userManager.getUser();
  return user;
}

export async function handleSilentCallback() {
  await userManager.signinSilentCallback();
  const user = await getUser();
  return user;
}

export async function getUserFromCallback() {
  let user = await getUser();
  if (!user) {
    user = await handleCallback();
  }
  return user;
}

export async function getUserFromSilentCallback() {
  let user = await getUser();
  if (!user) {
    user = await handleSilentCallback();
  }
  return user;
}

export async function logoutUser() {
  await userManager.signoutRedirect();
}

export async function signinSilent() {
  const userStore = useUserStore();
  if (userStore.isRecoveringAuth) return;
  userStore.setRecoveringAuth(true);
  try {
    const { refresh_token } = userStore.currentUser;
    const user = await userManager.signinSilent({
      extraQueryParams: {
        refresh_token,
      },
    });
    userStore.setCurrentUser(user);
  } catch (err) {
    // Renewal failed silently before this fix - surface it so the app can recover instead of expiring unnoticed.
    console.log('Silent token renewal failed', err);
    userStore.setAuth(false);
    throw err;
  } finally {
    userStore.setRecoveringAuth(false);
  }
}

userManager.events.addAccessTokenExpiring(() => {
  signinSilent().catch(() => {});
});

// Catches iframe/prompt=none renewal failures that don't always surface as a signinSilent() rejection.
userManager.events.addSilentRenewError((err) => {
  console.log('Silent renew error event', err);
  useUserStore().setAuth(false);
});
